/**
 * Integridade da Cadeia de Valor — página de resultado.
 * Consome o endpoint genérico /api/v1/assessments/submissions/{id}/result,
 * que já devolve total_max — o gauge e as barras se ajustam ao máximo de 350.
 */
import AssessmentIGAResultPage from './AssessmentIGAResultPage'

export default function AssessmentValueChainResultPage() {
  return (
    <AssessmentIGAResultPage
      eyebrow="Nai Compliance Center · Integridade da Cadeia de Valor"
      title="Supplier Integrity Maturity Assessment"
      maxScore={350}
      frameworkLabel="da integridade da cadeia de valor"
      footerLabel="Supplier Integrity Maturity Assessment"
    />
  )
}
